import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import breakpoint from 'tools/styled-components-breakpoint'
import { colors, colorConstants, marginSizes, padding, paddingSizes, margin, borderRadiusSizes } from 'theme/default'
import Flex from 'components/Flex'
import { H3, P } from 'components/Typo'
import IconArrow, { arrowDirections } from 'components/Icons/IconArrow'
import Collapsible from 'components/Collapsible'

const StyledFlex = styled(Flex).attrs(() => ({
  role: 'button',
  justifyContent: 'space-between',
  padding: paddingSizes.small,
  borderRadius: borderRadiusSizes.medium,
  marginTop: marginSizes.small
}))`
  background-color: ${props => props.error ? colors.alertErrorLight : colorConstants.lightestGray};
  cursor: pointer;
  ${breakpoint('desktop')`
    padding: ${padding[paddingSizes.medium]};
    padding-bottom: ${padding[paddingSizes.small]};
    padding-top: ${padding[paddingSizes.small]};
  `}
`

StyledFlex.defaultProps = {
  theme: {
    colorBackgroundColor: colors.background
  }
}

const TitleContainer = styled(Flex).attrs(() => ({
  flexDirection: 'column'
}))`
  width: 60%;
`

const SelectedContainer = styled(Flex).attrs(() => ({
  alignItems: 'center',
  justifyContent: 'flex-end'
}))`
  width: 40%;
`

const StyledIconArrow = styled(IconArrow).attrs(() => ({
  fill: colorConstants.black
}))`
  margin-left: ${margin[marginSizes.small]};
`

StyledIconArrow.propTypes = {
  show: PropTypes.bool
}

const StyledH3 = styled(H3)`
  color: ${props => props.error ? colors.alertError : colors.heading};
  margin: 0;
`

const StyledText = styled(P)`
  color: ${props => props.error ? colors.alertError : colorConstants.defaultText};
  margin: 0;
`

export const Header = ({ error, show, title, subtitle, body, bodySubText, hideArrow, className }) => (
  <StyledFlex error={error} show={show}>
    <TitleContainer flexDirection='column' className={className}>
      <StyledH3 error={error}>{title}</StyledH3>
      <StyledText error={error}>{subtitle}</StyledText>
    </TitleContainer>
    <SelectedContainer>
      <Flex flexDirection='column' alignItems='flex-end'>
        <StyledText textAlign='right' error={error}>{body}</StyledText>
        <StyledText data-testid='text.bodySubText' error={error}>{bodySubText}</StyledText>
      </Flex>
      {!hideArrow &&
      <Flex><StyledIconArrow iconSize='medium' direction={show ? arrowDirections.up : arrowDirections.down} /></Flex>
      }
    </SelectedContainer>
  </StyledFlex>
)
Header.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  body: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  error: PropTypes.bool,
  bodySubText: PropTypes.string,
  hideArrow: PropTypes.bool
}

export const ContentContainer = ({ children, show }) => (
  <Collapsible show={show} mountOnEnter>
    <Flex flexDirection='column'>
      {children}
    </Flex>
  </Collapsible>
)
ContentContainer.propTypes = {
  show: PropTypes.bool
}

export const ItemContainer = styled(Flex).attrs(() => ({
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: paddingSizes.small
}))`
  min-height: 65px;
  ${props => props.disabled ? 'opacity: 0.5;' : ''}
  ${props => props.last ? '' : `border-bottom: 1px ${props.theme.colorLinesAndBorders} solid;`}
  ${breakpoint('desktop')`
    padding: ${padding[paddingSizes.medium]};
    padding-bottom: ${padding[paddingSizes.small]};
    padding-top: ${padding[paddingSizes.small]};
  `}
`
ItemContainer.defaultProps = {
  theme: {
    colorLinesAndBorders: colors.separator
  }
}
